import React from 'react';
import { format } from 'date-fns';
import { SLOT_HEIGHT_PX, GRID_CLOSE_FOOTER_PX } from '../utils/timeGrid';
import '../styles/TeamLabelCalendar.css';

export default function TimeGutter({
  slots,
  gridEnd = null,
  closeFooterPx = GRID_CLOSE_FOOTER_PX,
  className = '',
}) {
  return (
    <div className={`team-cal-v3__gutter ${className}`.trim()} aria-hidden>
      {slots.map((slot, idx) => {
        const isLastSlot = idx === slots.length - 1;
        const showCloseLabel = isLastSlot && gridEnd;

        return (
          <div
            key={slot.time?.toISOString?.() || idx}
            className={`team-cal-v3__gutter-cell${slot.isHourStart ? ' team-cal-v3__gutter-cell--hour' : ' team-cal-v3__gutter-cell--half'}${showCloseLabel ? ' team-cal-v3__gutter-cell--closes' : ''}`}
            style={{ height: SLOT_HEIGHT_PX }}
          >
            <span className="team-cal-v3__gutter-label">
              {`${format(slot.time, 'h:mm')}\u00A0${format(slot.time, 'a')}`}
            </span>
            {showCloseLabel ? (
              <span className="team-cal-v3__gutter-label team-cal-v3__gutter-label--close">
                {`${format(gridEnd, 'h:mm')}\u00A0${format(gridEnd, 'a')}`}
              </span>
            ) : null}
          </div>
        );
      })}
      {closeFooterPx > 0 ? (
        <div
          className="team-cal-v3__gutter-pad"
          style={{ height: closeFooterPx }}
          aria-hidden
        />
      ) : null}
    </div>
  );
}
